// extracted by mini-css-extract-plugin
module.exports = {"rights":"_4a7644","rights__icon":"_4a8416","rights__icon-active":"f61d72"};